import { render, staticRenderFns } from "./NotaCaa.vue?vue&type=template&id=38a37790&"
import script from "./NotaCaa.vue?vue&type=script&lang=js&"
export * from "./NotaCaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports